import { get, post } from '../utils/request'


export const getSessionId = async (params) => {
    return await post('http://test-saas-zz.sixun.com.cn/Account/SuperUserToBigData?tenantId=433123', params, true)
}

export async function getToken(params) {
    return await get('api/v1/Account//GetAppToken', params)
}

export async function buildMiniProgramCode(data) {
    return await get('api/v1/Account/BuildMiniProgramCode', data)
}

export async function checkLogin(data) {
    return await get('api/v1/Account/CheckLogin', data)
}